export default __webpack_public_path__ + "images/GLX.27b6cba.png";